module.exports = __webpack_public_path__ + "img/r.b976d765.jpg";